import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { numberWithCommas } from 'helpers/Utils.js';
import ContainerCard from '@bit/knotchinc.web-react-components.container-card';
import Text from '@bit/knotchinc.web-react-components.text';
import {
  StyledFolderEntityTitle,
  StyledFloatingLogoContainer,
  StyledEntityIcon,
  StyledContentNum,
  StyledContentIcon,
  StyledContentNumContainer,
} from './styled.js';

const FolderCard = ({
  data: {
    public_id: partnerId,
    name: partnerName,
    type: partnerType,
    logo_url: partnerLogo,
    banner_image_url: partnerBanner,
    num_contents,
  },
  entity = {},
  contentType,
  history,
}) => {
  const {
    public_id: entityId,
    name: entityName,
    type: entityType,
    logo_url: entityLogo,
  } = entity;
  const createSingleEntityURL = (type, id) => `/blueprint/${type}/${id}`;
  const partnershipURL = `/blueprint/${entityType}/${entityId}/${partnerType || 'hub'}/${partnerId}`;
  const imgUrl = partnerBanner || partnerLogo;
  const isPaid = contentType === 'paid';

  return (
    <ContainerCard imgUrl={imgUrl} onClick={() => history.push(partnershipURL)}>
      <StyledFloatingLogoContainer>
        <StyledEntityIcon icon={partnerLogo} as={Link} to={createSingleEntityURL(partnerType, partnerId)} />
        {isPaid && <StyledEntityIcon icon={entityLogo} as={Link} to={createSingleEntityURL(entityType, entityId)} />}
      </StyledFloatingLogoContainer>
      <Text fontSize="16px" mb="5px">
        {partnerName}
      </Text>
      {isPaid ?
        <React.Fragment>
          <StyledFolderEntityTitle as={Link} to={createSingleEntityURL(partnerType, partnerId)}>
            {`${partnerName}`}
          </StyledFolderEntityTitle>
          <StyledFolderEntityTitle>{' & '}</StyledFolderEntityTitle>
          <StyledFolderEntityTitle as={Link} to={createSingleEntityURL(entityType, entityId)}>
            {entityName}
          </StyledFolderEntityTitle>
        </React.Fragment>
       : null}
      <StyledContentNumContainer>
        <StyledContentIcon type="article" />
        <StyledContentNum>{numberWithCommas(num_contents)}</StyledContentNum>
      </StyledContentNumContainer>
    </ContainerCard>
  );
};

export default withRouter(FolderCard);
